import { render } from "./StrategyCopyComponent.vue?vue&type=template&id=8ac392de&scoped=true&ts=true"
import script from "./StrategyCopyComponent.vue?vue&type=script&lang=ts"
export * from "./StrategyCopyComponent.vue?vue&type=script&lang=ts"

import "./StrategyCopyComponent.vue?vue&type=style&index=0&id=8ac392de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac392de"]])

export default __exports__